import { TableCell, TableActions } from 'components'
import formatDate from 'utils/dates/formatDate'
import sortTableDates from 'utils/global/sortTableDates'

const sortNameOfDeceased = (rowA, rowB) => {
  const nameA = rowA.original.case?.name_of_deceased?.toLowerCase() || ''
  const nameB = rowB.original.case?.name_of_deceased?.toLowerCase() || ''
  const returnValue = nameA.localeCompare(nameB)
  return returnValue
}

const sortCaseId = (rowA, rowB) => {
  const idA = (
    rowA.original.case.editable_case_id ||
    rowA.original.case_id ||
    ''
  )
    .toString()
    .toLowerCase()
  const idB = (
    rowB.original.case.editable_case_id ||
    rowB.original.case_id ||
    ''
  )
    .toString()
    .toLowerCase()
  return idA.localeCompare(idB)
}

const sortCreatedBy = (rowA, rowB) => {
  const nameA = rowA.original.created_by_name?.toLowerCase() || ''
  const nameB = rowB.original.created_by_name?.toLowerCase() || ''
  return nameA.localeCompare(nameB)
}

const rightAligned = { display: 'flex', justifyContent: 'flex-end' }

export const OrdersTable = ({
  t,
  itemsLoaded,
  showingArchived,
  archive,
  editPackage,
  openDuplicateOrder,
}) => {
  return [
    // Deceased Name
    {
      Header: t('table.deceasedName'),
      accessor: 'case.name_of_deceased',
      sortType: sortNameOfDeceased,
      Cell: ({ value }) => (
        <TableCell text={value || '---'} loaded={itemsLoaded} />
      ),
    },

    // Case
    {
      Header: t('table.case'),
      accessor: 'case.editable_case_id',
      sortType: sortCaseId,
      Cell: ({
        row: {
          original: {
            case: { editable_case_id },
            case_id,
          },
        },
      }) => (
        <TableCell
          text={editable_case_id || case_id}
          loaded={itemsLoaded}
          truncate={13}
        />
      ),
    },

    // Date of Death
    {
      Header: t('table.dateOfDeath'),
      accessor: 'case.date_of_death',
      style: rightAligned,
      sortType: (rowA, rowB) =>
        sortTableDates(rowA, rowB, 'sortable_date_of_death'),
      Cell: ({ value }) => (
        <TableCell text={formatDate(value, 'PP')} loaded={itemsLoaded} />
      ),
    },

    // Date Created
    {
      Header: t('table.dateCreated'),
      accessor: 'created_at',
      style: rightAligned,
      sortType: (rowA, rowB) =>
        sortTableDates(rowA, rowB, 'sortable_created_at'),
      Cell: ({ value }) => (
        <TableCell text={formatDate(value, 'PP')} loaded={itemsLoaded} />
      ),
    },

    // Created By
    {
      Header: t('table.createdBy'),
      accessor: 'created_by_name',
      sortType: sortCreatedBy,
      Cell: ({ value }) => <TableCell text={value} loaded={itemsLoaded} />,
    },

    // Actions
    {
      Header: t('table.actions.actions'),
      style: rightAligned,
      accessor: '',
      disableSortBy: true,
      Cell: ({ row }) => (
        <TableActions
          loaded={itemsLoaded}
          actions={[
            {
              text: showingArchived
                ? t('table.actions.unarchive')
                : t('table.actions.archive'),
              icon: 'archive',
              onClick: () => archive(false, row),
            },
            {
              text: t('table.actions.duplicate'),
              icon: 'duplicate',
              //open cases modal
              onClick: () => openDuplicateOrder(row.original.id),
            },
            {
              text: t('table.actions.edit'),
              icon: 'pencil',
              onClick: () => editPackage(row.original.id),
            },
          ]}
        />
      ),
    },
  ]
}

export default OrdersTable
